import type {
  AnalyticsFilterDto,
  ClientFilterDto,
  CriteriaGroupDto,
  PlatformFilterDto,
  RevenueTierFilterDto,
  SegmentCriteriaDto,
  UserFilterDto,
  UtmFilterDto,
} from '../generated/social-media/metapicSocialMediaAPIDocumentation.schemas'
import type { CamelCased } from '../types/requests.types'

/** One filter node in a criteria group. */
export type CriteriaChild = CriteriaGroupDto['children'][number]

/**
 * What comes back from the detail endpoint: the client camel-cases responses, so a stored tree has
 * `windowDays` where the write DTO has `window_days`. Everything else is single-word and identical.
 */
export type StoredCriteria = SegmentCriteriaDto | CamelCased<SegmentCriteriaDto>

/*
 * Orval gives every filter DTO the same `kind` union (all eight literals), so the children are not
 * a discriminated union and `switch` cannot narrow them. These guards do the narrowing by hand.
 */
const isKind =
  <T extends CriteriaChild>(kind: string) =>
  (child: CriteriaChild): child is T =>
    child.kind === kind

export const isPlatformFilter = isKind<PlatformFilterDto>('filter.platform')
export const isClientFilter = isKind<ClientFilterDto>('filter.client')
export const isRevenueTierFilter = isKind<RevenueTierFilterDto>('filter.revenue-tier')
export const isAnalyticsFilter = isKind<AnalyticsFilterDto>('filter.analytics')
export const isUtmFilter = isKind<UtmFilterDto>('filter.utm')
export const isUserFilter = isKind<UserFilterDto>('filter.user')
